'use strict';

var tealium = require('../tealium'),
	util = require('../../../../../app_fbb_core/cartridge/js/util');
	

var search = {
    init: function (){
    	// handle events for updating grid
    	var $main = $('#main');
    	$main.on('click', '.refinements a', function(e) {
        	// don't intercept for category and folder refinements, as well as unselectable
        	if ($(this).parents('.category-refinement').length > 0 || $(this).parents('.folder-refinement').length > 0 || $(this).parent().hasClass('unselectable')) {
            	return;
        	}
        	e.preventDefault();
        	if(!$('body').hasClass('single-column-refinement')){
        	var obj = {
        		event_name:"product_filtering",
        		product_filtering_category:$(this).data("prefn"),
        		product_filtering_value:$(this).data("prefv")
        		};
        	if(utag_data.customer_id) {
        		obj.customer_id = utag_data.customer_id;
        	}
        	tealium.triggerEvent(obj);
        	
        	}else if($('body').hasClass('single-column-refinement') && $(this).hasClass('apply-button-link') && this.href.indexOf('javascript:void(0)') < 0){
        		var obj = {
        	               event_name:"product_filtering"
        	               };
        	           var multiple_filter=[];
        	           $('.refinements a').each(function () {
        	               if($(this).closest('li').hasClass('selected')){
        	                   multiple_filter.push({
        	                   "product_filtering_category": $(this).data("prefn"),
        	                   "product_filtering_value":$(this).data("prefv")
        	               });        	                      
        	               }
        	           });
        	           obj={...obj,filters_applied:{...multiple_filter}};
        	           
        	           if(utag_data.customer_id) {
        	        		obj.customer_id = utag_data.customer_id;
        	        	}
        	        	tealium.triggerEvent(obj);
        	}
    	});  
    	$(document.body).off('click', '.swatchanchor').on('click', '.swatchanchor', function(e) {
    		e.preventDefault();
        	var obj = $(this).data("swatch");
        	if(obj){
        		obj.event_name = "product_interaction";
                obj.product_viewtype = "quickview";
                obj.mini_sps_id = [""];
                obj.uber_sps_id = [""];
        		tealium.triggerEvent(obj);
        	}
    	});    	
    	$main.on('click', '.clear-refinement a, .refine-by-clearall a, .breadcrumb-relax', function(e) {
        	e.preventDefault();
        	var obj = {
        		event_name:"product_clearFilter"
        		};
        	tealium.triggerEvent(obj);
    	});     	
		// handle sorting change
    	$main.on('change', '.sort-by select', function(e) { 
            e.preventDefault();
            var obj = {
            	event_name:"product_sort",
            	product_sorting:$(this).find('option:selected').data("sortby")
            } 
            if(utag_data.search_results){
            	obj.product_sorting_resultsnum = utag_data.search_results;
            }
            var pageNum = $main.find('.pagination .current-page');
            if(pageNum[0]){
            	obj.list_pagenum = pageNum[0].innerHTML;
            } else {
            	obj.list_pagenum = "1";
            }
            
            tealium.triggerEvent(obj);   		
    	});   	
        // Add to Wishlist 
    	$(document.body).off('click', '[data-action="wishlist"]').on('click', '[data-action="wishlist"]', function () {
        	var data =$(this).closest('form').data('productinfo');
        	console.log(data);
    	}); 
    	$(document.body).off('click', '.product-thumbnails img').on('click', '.product-thumbnails img', function(e) {
    		e.preventDefault();
        	var obj = {
        		event_name : "product_interaction",
        		product_id : $(this).data("productid"),
        		product_interaction_type : "select image",
                product_viewtype : "quickview",
                mini_sps_id : [""],
                uber_sps_id : [""]       		
        	}
        	tealium.triggerEvent(obj);
    	}); 
        // Add to Wishlist 
    	$(document.body).off('click', '[data-action="wishlist"]').on('click', '[data-action="wishlist"]', function () {
        	var obj = {
        		event_name : "add_to_wishlist",
        		product_viewtype : "quickview"         		      		
        	}
        	tealium.triggerEvent(obj);
    	});
    	
    	var $tile =$('ul.plp-category-page li.grid-tile .product-tile');
    	$tile.off('click','.product-name-image-container').on('click','.product-name-image-container',function() {
    		var styleID = '',
    			masterID = '';
    		if($(this).closest('.product-tile').find("input[name='style-id']").length > 0){
    			styleID = $(this).closest('.product-tile').find("input[name='style-id']").val();
    		}
    		masterID = $(this).closest('.product-tile').find("input[name='master-id']").val();
    		
    		var obj = {
        		event_name : "search_results_click",
        		product_id : masterID,
        		product_sku : styleID         		      		
        	}
        	tealium.triggerEvent(obj);

        	if(typeof (MERCH_UTILS) !== 'undefined') {
        		if(document.URL.indexOf("q=") != -1){
        			MERCH_UTILS.setProductFindingMethodCookie("site_search");
        		} else {
        			MERCH_UTILS.setProductFindingMethodCookie("browse");
        		}
        	}
    	});
    }
}
exports.init = search.init;
